import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Chart } from 'chart.js/auto';
import { MapService } from '../../services/map.service';
// import { Observable, Subject } from 'rxjs';
import Graphic from '@arcgis/core/Graphic';

@Component({
    selector: 'app-inner-dashboard',
    templateUrl: './inner-dashboard.component.html',
    styleUrls: ['./inner-dashboard.component.scss']
})
export class InnerDashboardComponent implements OnInit {
    // private mapFeatures$: Subject<any[]>;
    // private mpfeatures : [];
    public planFieldNames: any[];
    public parcelFieldNames: any[];
    public chartLayer: String;
    constructor(
        private http: HttpClient,
        private mapService: MapService
    ) { }

    ngOnInit() {
        // this.mapFeatures$ = new Subject<any[]>() ;

        this.http
            .get<any>(
                'http://192.168.8.104:6080/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/4/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=parcel_plane,Parcel_AsBuilt,MadinahAerialPhotography_zone,PLAN_CORRECT,Zoon_Code,Comparison,Balady_2,F3D'
            )
            .subscribe((response: any) => {
                const that = this;
                console.log(response);
                console.log(response.features);
                if (response && response.fields) {
                    this.planFieldNames = [
                        'parcel_plane',
                        'Parcel_AsBuilt',
                        'MadinahAerialPhotography_zone',
                        'PLAN_CORRECT',
                        'Zoon_Code',
                        'Comparison',
                        'Balady_2',
                        'F3D'
                    ];
                    // const planFieldIndices = this.planFieldNames.map(fieldName => response.fields.findIndex(field => field.name === fieldName));
                    // if(planFieldIndices.every(index => index !== -1)){
                    const field1Counts = {};
                    const field2Counts = {};
                    const field3Counts = {};
                    const field4Counts = {};
                    const field5Counts = {};
                    const field6Counts = {};
                    const field7Counts = {};
                    const field8Counts = {};
                    // console.log(planFieldIndices);
                    response.features.forEach((feature) => {
                        const field1Value =
                            feature.attributes[this.planFieldNames[0]];
                        const field2Value =
                            feature.attributes[this.planFieldNames[1]];
                        const field3Value =
                            feature.attributes[this.planFieldNames[2]];
                        const field4Value =
                            feature.attributes[this.planFieldNames[3]];
                        const field5Value =
                            feature.attributes[this.planFieldNames[4]];
                        const field6Value =
                            feature.attributes[this.planFieldNames[5]];
                        const field7Value =
                            feature.attributes[this.planFieldNames[6]];
                        const field8Value =
                            feature.attributes[this.planFieldNames[7]];

                        field1Counts[field1Value] =
                            (field1Counts[field1Value] || 0) + 1;
                        field2Counts[field2Value] =
                            (field2Counts[field2Value] || 0) + 1;
                        field3Counts[field3Value] =
                            (field3Counts[field3Value] || 0) + 1;
                        field4Counts[field4Value] =
                            (field4Counts[field4Value] || 0) + 1;
                        field5Counts[field5Value] =
                            (field5Counts[field5Value] || 0) + 1;
                        field6Counts[field6Value] =
                            (field6Counts[field6Value] || 0) + 1;
                        field7Counts[field7Value] =
                            (field7Counts[field7Value] || 0) + 1;
                        field8Counts[field8Value] =
                            (field7Counts[field7Value] || 0) + 1;
                    });

                    this.createChart('MyChart1', field1Counts, 'parcel_plane', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart(
                        'MyChart2',
                        field2Counts,
                        'Parcel_AsBuilt',
                        ['Label 1', 'Label 2']
                    );
                    this.createChart(
                        'MyChart3',
                        field3Counts,
                        'MadinahAerialPhotography_zone',
                        ['Label 1', 'Label 2']
                    );
                    this.createChart('MyChart4', field4Counts, 'PLAN_CORRECT', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart('MyChart5', field4Counts, 'Zoon_Code', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart('MyChart6', field4Counts, 'Comparison', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart('MyChart7', field4Counts, 'Balady_2', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart('MyChart8', field4Counts, 'F3D', [
                        'Label 1',
                        'Label 2'
                    ]);
                    console.log(field1Counts);
                    // }
                }
            });

        //-----------parcelCharts-----

        this.http
            .get<any>(
                'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=zoon_code,BALLADY_2,AREA_PHOTOGRAPHY,Plan_Correction'
            )
            .subscribe((response: any) => {
                const that = this;
                console.log(response);
                console.log(response.features);
                if (response && response.fields) {
                    this.parcelFieldNames = [
                        'zoon_code',
                        'BALLADY_2',
                        'AREA_PHOTOGRAPHY',
                        'Plan_Correction'
                    ];
                    // const parcelFieldIndices = this.parcelFieldNames.map(fieldName => response.fields.findIndex(field => field.name === fieldName));
                    // console.log(parcelFieldIndices);
                    console.log(response.fields);
                    // console.log(response.features);

                    // if(parcelFieldIndices.every(index => index !== -1)){
                    const field11Counts = {};
                    const field12Counts = {};
                    const field13Counts = {};
                    const field14Counts = {};

                    response.features.forEach((feature) => {
                        // console.log(feature);
                        const field11Value =
                            feature.attributes[this.parcelFieldNames[0]];
                        const field12Value =
                            feature.attributes[this.parcelFieldNames[1]];
                        const field13Value =
                            feature.attributes[this.parcelFieldNames[2]];
                        const field14Value =
                            feature.attributes[this.parcelFieldNames[3]];

                        field11Counts[field11Value] =
                            (field11Counts[field11Value] || 0) + 1;
                        field12Counts[field12Value] =
                            (field12Counts[field12Value] || 0) + 1;
                        field13Counts[field13Value] =
                            (field13Counts[field13Value] || 0) + 1;
                        field14Counts[field14Value] =
                            (field14Counts[field14Value] || 0) + 1;
                    });
                    // debugger;
                    this.createChart('MyChart11', field11Counts, 'zoon_code', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart('MyChart12', field12Counts, 'BALLADY_2', [
                        'Label 1',
                        'Label 2'
                    ]);
                    this.createChart(
                        'MyChart13',
                        field13Counts,
                        'AREA_PHOTOGRAPHY',
                        ['Label 1', 'Label 2']
                    );
                    this.createChart(
                        'MyChart14',
                        field14Counts,
                        'Plan_Correction',
                        ['Label 1', 'Label 2']
                    );
                    console.log(field11Counts);
                    // }
                }
            });
    }

    createChart(
        canvasId: string,
        chartData: { [key: string]: number },
        chartTitle: string,
        legendLabels: string[]
    ) {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        const that = this;
        if (!canvas) {
            console.error(`Canvas element with ID "${canvasId}" not found.`);
            return;
        }

        if (Object.keys(chartData).length === 0) {
            console.error(`No data available for chart "${canvasId}".`);
            return;
        }

        // if(canvas.id=="MyChart1"|| canvas.id== "MyChart2"|| canvas.id=="MyChart3"){
        //   this.chartLayer= "PlanLayer";
        // }else if (canvas.id=="MyChart5"||canvas.id== "MyChart6"|| canvas.id=="MyChart7"||canvas.id=="MyChart8"){
        //   this.chartLayer= "ParcelLayer";
        // }

        new Chart(canvas, {
            type: 'doughnut',

            data: {
                labels: Object.keys(chartData), //labels: legendLabels,
                datasets: [
                    {
                        data: Object.values(chartData),
                        backgroundColor: [
                            'rgba(103, 58, 183, 0.6)',
                            'rgba(38, 166, 154, 0.6)',
                            'rgba(0, 77, 64, 0.6)',
                            'rgba(26, 35, 126, 0.6)',
                            'rgba(106, 27, 154, 0.6)',
                            'rgba(74, 20, 140, 0.6)'
                        ]
                    }
                ]
            },
            options: {
                responsive: true,

                plugins: {
                    title: {
                        display: true,
                        text: chartTitle
                    }
                    // legend: {
                    //   labels: {
                    //     boxWidth: 10,
                    //     padding: 15,
                    //     color: '#000',
                    //     font: {
                    //       family: 'Arial',
                    //       size: 16
                    //     }
                    //   }
                    // }
                },
                onClick(event, elements, chart) {
                    let selected = chart.tooltip.title[0];
                    let chartIndex = chart.id;

                    that.selectFeatures(selected, chartIndex);

                    // console.log(canvas.id)
                    // console.log(this.chartLayer)
                    // console.log(chart.data.labels)
                    // console.log(elements)
                    // console.log(chart.config.options.plugins.title.text)
                    console.log(selected);
                    // console.log(that);
                    // console.log(chart)
                }
            }
        });
    }

    selectFeatures(selectedValue, canvasID) {
        const that = this;
        let planFieldName = this.planFieldNames[canvasID];
        let parcelFieldName = this.parcelFieldNames[canvasID];
        let lyr = this.chartLayer;

        // Clear previous graphics
        this.mapService.mapView.graphics.removeAll();

        const planQuery = {
            outFields: ['shape'],
            where: planFieldName + "='" + selectedValue + "'"
        };
        const parcelQuery = {
            outFields: ['shape'],
            where: parcelFieldName + "='" + selectedValue + "'"
        };

        if (planFieldName) {
            this.mapService.parBoundary
                .queryFeatures(planQuery)
                .then(function (response) {
                    const newSymbol = {
                        type: 'simple-fill',
                        color: [227, 139, 79, 0.8],
                        outline: {
                            color: [255, 255, 255],
                            width: 1
                        }
                    };

                    // Create a new graphic for each feature in the response
                    const graphics = response.features.map((feature) => {
                        return new Graphic({
                            geometry: feature.geometry,
                            symbol: newSymbol
                        });
                    });

                    // Add the graphics to the map
                    graphics.forEach((graphic) => {
                        console.log(that);
                        return that.mapService.mapView.graphics.add(graphic);
                    });
                    console.log(graphics.length);
                    // Zoom to the first graphic
                    if (graphics.length > 0) {
                        console.log(graphics[0]);
                        that.mapService.mapView.goTo(graphics);
                    }
                });
        }

        // console.log(planFieldName);
        // console.log(selectedValue);
        else if (parcelFieldName) {
            this.mapService.parcelLayer
                .queryFeatures(parcelQuery)
                .then(function (response) {
                    const newSymbol = {
                        type: 'simple-fill',
                        color: [227, 139, 79, 0.8],
                        outline: {
                            color: [255, 255, 255],
                            width: 1
                        }
                    };

                    // Create a new graphic for each feature in the response
                    const graphics = response.features.map((feature) => {
                        return new Graphic({
                            geometry: feature.geometry,
                            symbol: newSymbol
                        });
                    });

                    // Add the graphics to the map
                    graphics.forEach((graphic) => {
                        // console.log(that);
                        return that.mapService.mapView.graphics.add(graphic);
                    });
                    // console.log(graphics.length);

                    // Zoom to the first graphic
                    if (graphics.length > 0) {
                        console.log(graphics[0]);
                        that.mapService.mapView.goTo(graphics);
                    }
                });
        }
    }
}

//-----------------------------------------------------------------------------------------------------//

// import { Component, OnInit } from '@angular/core';
// import { HttpClient } from '@angular/common/http';
// import { Chart } from 'chart.js/auto';
// import { MapService } from 'src/app/services/map.service';

// @Component({
//   selector: 'app-inner-dashboard',
//   templateUrl: './inner-dashboard.component.html',
//   styleUrls: ['./inner-dashboard.component.scss']
// })
// export class InnerDashboardComponent implements OnInit {
//   public planFieldNames: any[];
//   public parcelFieldNames: any[];
//   public chartLayer: string;

//   constructor(private http: HttpClient, private mapService: MapService) {}

// ngOnInit() {
//   this.fetchOptions();
// }

// private fetchOptions(): void {
//   const planLayerUrl =
//     'http://192.168.1.106:6080/arcgis/rest/services/amanaFinal/AmanaFinal/FeatureServer/2/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=PLAN_CORRECT,Status,Aeria_photography';
//   const parcelLayerUrl =
//     'http://192.168.1.106:6080/arcgis/rest/services/amanaFinal/AmanaFinal/FeatureServer/1/query?f=pjson&where=1%3D1&returnGeometry=false&outFields=Plan_Correction,BALLADY_2,AREA_PHOTOGRAPHY,ZOON_Photography';

//   this.http.get(planLayerUrl).subscribe(
//     (response: any) => {
//       this.processLayerData(response, 'plan');
//     },
//     (error: any) => {
//       console.error('Error fetching options from the plan layer:', error);
//     }
//   );

//   this.http.get(parcelLayerUrl).subscribe(
//     (response: any) => {
//       this.processLayerData(response, 'parcel');
//     },
//     (error: any) => {
//       console.error('Error fetching options from the parcel layer:', error);
//     }
//   );
// }

// private processLayerData(response: any, layerType: string): void {
//   const features = response?.features;

//   if (features) {
//     features.forEach((feature: any) => {
//       if (layerType === 'plan') {
//         this.planFieldNames = ['PLAN_CORRECT', 'Status', 'Aeria_photography'];
//         const planData = this.processPlanData(features);
//         this.createChartsForPlan(planData);
//       } else if (layerType === 'parcel') {
//         this.parcelFieldNames = ['Plan_Correction', 'BALLADY_2', 'AREA_PHOTOGRAPHY', 'ZOON_Photography'];
//         const parcelData = this.processParcelData(features);
//         this.createChartsForParcel(parcelData);
//       }
//     });
//   }
// }

//   private processPlanData(features: any[]): any {
//     const fieldCounts: any = {};

//     features.forEach((feature) => {
//       this.planFieldNames.forEach((fieldName) => {
//         const fieldValue = feature.attributes[fieldName];
//         fieldCounts[fieldName] = fieldCounts[fieldName] || {};
//         fieldCounts[fieldName][fieldValue] = (fieldCounts[fieldName][fieldValue] || 0) + 1;
//       });
//     });

//     return fieldCounts;
//   }

//   private processParcelData(features: any[]): any {
//     const fieldCounts: any = {};

//     features.forEach((feature) => {
//       this.parcelFieldNames.forEach((fieldName) => {
//         const fieldValue = feature.attributes[fieldName];
//         fieldCounts[fieldName] = fieldCounts[fieldName] || {};
//         fieldCounts[fieldName][fieldValue] = (fieldCounts[fieldName][fieldValue] || 0) + 1;
//       });
//     });

//     return fieldCounts;
//   }

//   private createChartsForPlan(data: any): void {
//     this.createCharts(data, 'plan');
//   }

//   private createChartsForParcel(data: any): void {
//     this.createCharts(data, 'parcel');
//   }

//   private createCharts(data: any, layerType: string): void {
//     const fieldNames = layerType === 'plan' ? this.planFieldNames : this.parcelFieldNames;

//     fieldNames.forEach((fieldName, index) => {
//       const canvasId = `MyChart${index + 1}`;
//       const chartData = data[fieldName];
//       const legendLabels = Object.keys(chartData);
//       const chartTitle = fieldName;

//       this.createChart(canvasId, chartData, chartTitle, legendLabels);
//     });
//   }

//   private createChart(canvasId: string, chartData: { [key: string]: number }, chartTitle: string, legendLabels: string[]) {
//     const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
//     const ctx = canvas.getContext('2d');

//     new Chart(ctx, {
//       type: 'bar',
//       data: {
//         labels: legendLabels,
//         datasets: [
//           {
//             label: chartTitle,
//             data: Object.values(chartData),
//             backgroundColor: 'rgba(54, 162, 235, 0.5)',
//             borderColor: 'rgba(54, 162, 235, 1)',
//             borderWidth: 1
//           }
//         ]
//       },
//       options: {
//         scales: {
//           y: {
//             beginAtZero: true,
//             // precision: 0
//           }
//         }
//       }
//     });
//   }
// }
